import makeStyles from '@mui/styles/makeStyles'

import { CustomTheme } from '../../themes/types'

export const useStyles = makeStyles((theme: CustomTheme) => ({
    root: {
        margin: '100px auto',
        maxWidth: 1028,
    },
    successTitle: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'start',
        alignItems: 'center',
        marginBottom: 30,

        '& img': {
            marginRight: 15,
            width: 32,
            height: 32,
        },

        [theme.breakpoints.down('sm')]: {
            '& img': {
                marginRight: 15,
                marginBottom: 15,
            },
        },
    },
    successContent: {
        textAlign: 'left',
        '& h6': {
            color: `${theme.color.text.secondary}`,
            fontSize: 16,
            lineHeight: '20px',
            fontWeight: 400,
            marginBottom: 20,
            '&:last-child': {
                marginBottom: 0,
            },
        },
        '& strong': {
            color: `${theme.color.text.main}`,
            fontWeight: 600,
        },
    },
    successControls: {
        marginTop: 30,
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'flex-start',
            flexDirection: 'column',
        },

        '& h5': {
            color: `${theme.color.text.main}`,
            marginRight: 20,
            [theme.breakpoints.down('sm')]: {
                marginRight: 0,
                marginBottom: 20,
            },
        },

        '& a': {
            borderRadius: 23,
            height: 46,
        },
    },
    cardRoot: {
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        },
    },
    playGroundParagraph: {
        display: 'flex',
        marginBottom: '20px',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        },
    },
    playGroundTypography: {
        flex: 1,
    },
    playGroundButton: {
        flex: '0.4',
        marginLeft: 10,
    },
}))

export const newFormThemeOverrides = {
    MuiCard: {
        styleOverrides: {
            root: {
                display: 'flex',
            },
        },
    },
    MuiCardMedia: {
        styleOverrides: {
            root: {
                flex: 1,
                objectFit: 'cover',
                minWidth: 410,
            },
        },
    },
    MuiCardContent: {
        styleOverrides: {
            root: {
                padding: 30,
                flex: 2,
            },
        },
    },
}
